import { render, staticRenderFns } from "./AcoesEnviosOcorrencia.vue?vue&type=template&id=8049bc4e&scoped=true"
import script from "./AcoesEnviosOcorrencia.vue?vue&type=script&lang=js"
export * from "./AcoesEnviosOcorrencia.vue?vue&type=script&lang=js"
import style0 from "./AcoesEnviosOcorrencia.vue?vue&type=style&index=0&id=8049bc4e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8049bc4e",
  null
  
)

export default component.exports